export default __webpack_public_path__ + "static/media/P2P_Manual.773406e9.jpg";